export default function log(label, ...args) {
  if (window.extellio.debug) {
    console.log(`[EXTELLIO] ${label}`, ...args); // eslint-disable-line no-console
  }
}
